const initialState = {
  requesting: false,
  successful: false,
  error: false,
  userChanged: null,
};

const changePasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHANGEPASSWORD_REQUESTING":
      return {
        requesting: true,
        successful: false,
        error: false,
      };
    case "CHANGEPASSWORD_SUCCESS":
      return {
        error: false,
        requesting: false,
        successful: true,
        userChanged: action.value,
      };
    case "CHANGEPASSWORD_ERROR":
      return {
        error: true,
        requesting: false,
        successful: false,
      };
    case "CHANGEPASSWORD_RESET":
      return initialState;
    default:
      return state;
  }
};

export default changePasswordReducer;
